<template>
  <generic-modal :title="$t('bulk process')" ref="generic_modal">
    <div class="message is-info">
      <div class="message-body">
        <p>
          {{
            $t(
              "when the process starts, the configured database will be consulted and the records obtained will be processed one by one and the sirc will be consulted to obtain your credit information"
            )
          }}
        </p>
      </div>
    </div>
    <div class="message is-warning" v-if="bulk_info">
      <div class="message-body">
        <p>{{ $t("record count") }}: {{ bulk_info.record_count }}</p>
        <p>{{ $t("chunk size") }}: {{ bulk_info.chunk_size }}</p>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-play"></i>
        </span>
        <span>{{ $t("start") }}</span>
      </button>
      <button class="button is-rounded" @click="calculate">
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("calculate bulk") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "FactoringModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      bulk_info: undefined,
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/factoring", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      put("/sirc-credit-information/bulk", {})
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        selected_start: "now",
      };
      v.error = "";
      // v.uuid = "";
    },
    calculate() {
      let v = this;
      v.$root.loader(true);
      get("/sirc-credit-information/bulk/calculate", {})
        .then((bulk_info) => {
          v.bulk_info = bulk_info;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
